module.exports = __webpack_public_path__ + "static/media/296035.8331ca8e.png";